<template>
  <div>
    <div style="text-align: center; margin-top: 100px">正在支付中，请稍后...</div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { toTradeQuery } from '@/api/order';

export default {
  components: {},
  data() {
    return {
      orderId: '',
      pollingTimer: null, // 轮询定时器
      isPolling: false    // 防止重复开启轮询
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    const payType = this.$route.query.type === '1' ? 'A01' : 'W01';
    Dialog.confirm({
      title: '温馨提示',
      message: '是否支付成功？(支付完成前，请不要关闭此支付验证窗口)',
      showCancelButton: false
    }).then(() => {
      toTradeQuery({ orderId: this.orderId, ordPayType: payType })
          .then(res => {
            const result = res?.data?.data?.result;
            console.log('对账结果:', result);

            if (result !== '2') {
              this.stopPolling();
              this.$utils.showToast('支付成功！');
              this.$router.replace({
                path: '/paySuccess',
                query: {
                  orderNo:res.data.data.orderNo,
                  dz: 1
                }
              });
            }else{
              this.$utils.showToast(res.data.data.msg);
              this.$router.replace('/my');
            }
          })
    });
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    startPolling() {
      if (this.isPolling) return; // 防重
      this.isPolling = true;

      const payType = this.$route.query.type === '1' ? 'A01' : 'W01';

      this.pollingTimer = setInterval(() => {
        toTradeQuery({ orderId: this.orderId, ordPayType: payType })
          .then(res => {
            const result = res?.data?.data?.result;
            console.log('对账结果:', result);

            if (result !== '2') {
              this.stopPolling();
              this.$utils.showToast('支付成功！');
              this.$router.replace({
                path: '/paySuccess',
                query: {
                  orderNo:res.data.data.orderNo,
                  dz: 1
                }
              });
            }
            // else{
            //   this.$utils.showToast(res.data.data.msg);
            //   this.$router.replace('/myOrder');
            // }
          })
          .catch(err => {
            console.error('对账请求失败:', err);
          });
      }, 1000); // 每2秒一次
    },

    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
      this.isPolling = false;
    }
  }
};
</script>

<style></style>